<template>
  <div>
    <div class="d-flex flex-column-fluid">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-lg-12 col-xl-12">
                <div class="card card-custom gutter-b bg-transparent shadow-none border-0">
                  <div class="card-header align-items-center border-bottom-dark px-0">
                    <div class="card-title mb-0">
                      <h3 class="card-label mb-0 font-weight-bold text-body">
                        Cart Items
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="card card-custom gutter-b bg-white border-0">
                  <div class="card-body">
                    <div class="dataTables_wrapper no-footer">

                      <div class="cart-toolbar">
                        <label class="mb-0 text-nowrap">Show
                          <select v-model="limit" v-on:change="fetchItems()">
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                          </select>
                          entries
                        </label>

                        <div class="custom-control custom-switch custom-switch-info contact-switch" :class="{ on: knownOnly }">
                          <input type="checkbox" class="custom-control-input" id="cartKnownOnly" v-model="knownOnly" @change="fetchItems()">
                          <label class="custom-control-label" for="cartKnownOnly">
                            Only visitors with contact info
                            <span class="d-block small text-muted">Hide anonymous visitors with no email or phone</span>
                          </label>
                        </div>

                        <div class="d-flex align-items-center text-nowrap" style="gap:6px;">
                          <span class="text-muted small">From</span>
                          <input type="date" class="form-control form-control-sm" v-model="from" :max="to || null" @change="fetchItems()">
                          <span class="text-muted small">to</span>
                          <input type="date" class="form-control form-control-sm" v-model="to" :min="from || null" @change="fetchItems()">
                        </div>

                        <div class="d-flex align-items-center ml-lg-auto" style="gap:6px;">
                          <input type="search" class="form-control form-control-sm" v-model="search" @input="debouncedFetch()" placeholder="Name, email or phone" style="min-width:190px;">
                          <button v-if="search !== '' || from || to" type="button" class="btn btn-light btn-sm text-nowrap" @click="clearFilters">Clear</button>
                          <button type="button" class="btn btn-primary btn-sm text-nowrap" :disabled="exporting" @click="exportCsv"
                            title="One row per person with email/phone, using the filters above">
                            {{ exporting ? 'Preparing...' : 'Export to Excel' }}
                          </button>
                        </div>
                      </div>

                      <table class="display dataTable no-footer" style="width:100%">
                        <thead class="text-body">
                          <tr>
                            <th>#</th>
                            <th>Customer</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Product</th>
                            <th>Qty</th>
                            <th>Added At</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="items.length === 0">
                            <td colspan="7" class="text-center">No records found.</td>
                          </tr>
                          <tr v-for="item in items" :key="item.id">
                            <td>{{ item.id }}</td>
                            <td>
                              <span v-if="item.customer && item.customer.first_name !== 'visit'">
                                {{ item.customer.first_name }} {{ item.customer.last_name }}
                              </span>
                              <span v-else-if="item.customer" class="text-muted">Visitor #{{ item.customer.id }}</span>
                              <span v-else class="text-muted">Guest</span>
                            </td>
                            <td>
                              <template v-if="item.contact && item.contact.email">
                                {{ item.contact.email }}
                                <span v-if="item.contact.renamed" class="badge badge-light ml-1"
                                  title="Saved as a renamed duplicate (name_old_ID@...) after the same email was used again at checkout. This is the real address.">dup</span>
                                <span v-if="item.contact.from_coupon" class="badge badge-success ml-1" :title="'Coupon ' + item.contact.coupon">coupon</span>
                              </template>
                              <span v-else class="text-muted small">Not captured yet</span>
                            </td>
                            <td>
                              <span v-if="item.contact && item.contact.known">{{ item.contact.phone }}</span>
                              <span v-else class="text-muted small">—</span>
                            </td>
                            <td>
                              <span v-if="item.product && item.product.detail && item.product.detail.length > 0">
                                {{ item.product.detail[0].title }}
                              </span>
                              <span v-else class="text-muted">—</span>
                            </td>
                            <td>{{ item.qty }}</td>
                            <td>{{ item.created_at }}</td>
                          </tr>
                        </tbody>
                      </table>

                      <!-- Pagination -->
                      <div class="dataTables_paginate paging_simple_numbers">
                        <ul class="pagination">
                          <li class="paginate_button page-item" :class="{ disabled: !meta.prev_page_url }">
                            <a class="page-link" href="#" @click.prevent="fetchItems(meta.prev_page_url)">Previous</a>
                          </li>
                          <li class="paginate_button page-item active">
                            <a class="page-link" href="#">{{ meta.current_page }} / {{ meta.last_page }}</a>
                          </li>
                          <li class="paginate_button page-item" :class="{ disabled: !meta.next_page_url }">
                            <a class="page-link" href="#" @click.prevent="fetchItems(meta.next_page_url)">Next</a>
                          </li>
                        </ul>
                        <div class="mt-2 text-muted">Total: {{ meta.total }} records</div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [],
      meta: {},
      limit: 25,
      search: '',
      knownOnly: true,
      from: '',
      to: '',
      exporting: false,
      timer: null,
      token: {},
    };
  },
  methods: {
    filterQuery() {
      let q = 'limit=' + this.limit;
      if (this.search !== '') q += '&search=' + encodeURIComponent(this.search);
      if (this.knownOnly) q += '&known=1';
      if (this.from) q += '&from=' + this.from;
      if (this.to) q += '&to=' + this.to;
      return q;
    },
    fetchItems(page_url) {
      let url = page_url || '/api/admin/admin-cart-items';
      // paginator links already carry the old query, so drop it before adding the current one
      url = url.replace(/[?&](limit|search|known|from|to)=[^&]*/g, '');
      url += (url.includes('?') ? '&' : '?') + this.filterQuery();
      axios.get(url, this.token).then((res) => {
        this.items = res.data.data;
        this.meta  = res.data.meta;
      });
    },
    debouncedFetch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.fetchItems(), 300);
    },
    clearFilters() {
      this.search = '';
      this.from = '';
      this.to = '';
      this.fetchItems();
    },
    exportCsv() {
      // the API needs the bearer token, so a plain link would be refused
      this.exporting = true;
      axios.get('/api/admin/admin-cart-items/export?' + this.filterQuery(), Object.assign({ responseType: 'blob' }, this.token))
        .then((res) => {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(res.data);
          link.download = 'abandoned-carts-' + new Date().toISOString().slice(0, 10) + '.csv';
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(() => this.$toaster.error('Export failed, please try again.'))
        .finally(() => { this.exporting = false; });
    },
  },
  mounted() {
    const token = localStorage.getItem('token');
    this.token = { headers: { Authorization: `Bearer ${token}` } };
    this.fetchItems();
  },
};
</script>

<style scoped>
.cart-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 20px;
  margin-bottom: 16px;
}
.contact-switch {
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  padding: 6px 12px 6px 48px;
  transition: border-color .15s, background-color .15s;
}
.contact-switch.on {
  border-color: #8950fc;
  background: #f8f5ff;
}
.contact-switch .custom-control-label {
  cursor: pointer;
  font-weight: 500;
  line-height: 1.3;
}
</style>
